import { API_BASE_URL } from "src/config/apiBase";
import React, { useEffect, useState } from 'react';
import Select from 'react-select';
import CryptoJS from "crypto-js";
import { toast } from 'react-toastify';
import { getDecryptedUserFromCookie } from '../utils/getCookie';
import { decryptToken } from '../utils/getToken';
// import decryptUserCookie from './utils/decryptUserCookie';

const UnitModal = ({ isOpen, setIsOpen, selectedCategory, setSelectedCategory, onSave, categories, setCategories,fetchCategories }) => {
    const [name, setCategoryName] = useState('');
    const [status, setStatus] = useState(null);
    const urlmain = API_BASE_URL
    const user = getDecryptedUserFromCookie("gta_mainstateuser");
    const token = decryptToken("accessToken") || ""
    // const userDetails = decryptUserCookie();
    // const userDetails = {
    //     main_id: "12345"
    // }
    useEffect(() => {
        if (selectedCategory) {
            setCategoryName(selectedCategory.name);
            setStatus({ value: selectedCategory.status, label: selectedCategory.status });
        } else {
            setCategoryName('');
            setStatus(null);
        }
    }, [selectedCategory]);





    const statusOptions = [
        { value: 'Active', label: 'Active' },
        { value: 'Inactive', label: 'Inactive' },
    ];


    const handleSubmit = async (e) => {
        e.preventDefault();

        const categoryData = {
            name: name,
            status: status?.value,
            user_id: user.main_id,
            user_name: user.full_name || 'Admin'
        };

        const isEdit = !!selectedCategory?.id;
        const url = isEdit
            ? `${urlmain}/unit/${selectedCategory.id}`
            : `${urlmain}/unit/admin1997`;
        const method = isEdit ? "PUT" : "POST";

        try {
            const response = await fetch(url, {
                method,
                headers: {
                    "Content-Type": "application/json",
                     Authorization: `Bearer ${token}`,
                },
                body: JSON.stringify(categoryData),
            });

            const res = await response.json();
            if (response.ok) {
                setCategories(prev =>
                    isEdit
                        ? prev.map(cat => cat.id === selectedCategory.id ? { ...categoryData, id: selectedCategory.id } : cat)
                        : [...prev, { ...categoryData, id: res.id }]
                );
                fetchCategories();
                toast.success(isEdit ? "Unit updated" : "Unit added");
                setIsOpen(false);
                setSelectedCategory(null);
            } else {
                toast.error(res.message || "Operation failed");
            }
        } catch (error) {
            console.error("Error submitting unit:", error);
            toast.error("Unexpected error occurred");
        }
    };


    if (!isOpen) return null;

    return (
        <div className="custom-modal-overlay" >
            <div
                className="custom-modal-content"

            >
                <h2 className="oms-modal-title">Unit</h2>
                <form className="oms-modal-form" onSubmit={handleSubmit}>
                    <div className="oms-form-group">
                        <label htmlFor="name" className="oms-form-label">
                            Name
                        </label>
                        <input
                            type="text"
                            id="name"
                            value={name}
                            onChange={(e) => setCategoryName(e.target.value)}
                            placeholder="Enter name (for e.g kg, ml, gram, cm...)"
                        />
                    </div>

                    <div className="oms-form-group">
                        <label htmlFor="status" className="oms-form-label">
                            Status
                        </label>
                        <Select
                            id="status"
                            options={statusOptions}
                            value={status}
                            onChange={setStatus}
                            placeholder="Select status"
                        />
                    </div>
                    <div className="oms-form-actions">
                        <button type="button" onClick={() => setIsOpen(false)}>
                            Cancel
                        </button>
                        <button type="submit">Submit</button>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default UnitModal;
